import { useState, useEffect } from "react";
import { getMontoMensualPaqueteDetalle } from "../services/servicePaquete";
export const useCalcularMontoMensual = ({IdPaquete}) => {
    const [mensualidades, setMensualidades] = useState([]);
    useEffect(() => {
        const getCalculoMensualidad = () => {
            return getMontoMensualPaqueteDetalle({IdPaquete}).then(Response => {
                setMensualidades(Response)
            }).catch(Error => {
                setMensualidades([])
            })
        }
        getCalculoMensualidad();
        return () => {
            setMensualidades([])
        }
    }, [IdPaquete])
    return {mensualidades};
}